'use strict';

/** 
This is the adjusted sleep schedule for onboarding
**/
(function () {
  'use strict';

  angular.module('msSleep').component('msSleepScheduleCheckin', {
    templateUrl: 'sleep/templates/sleep-schedule-checkin.html',
    controller: SleepScheduleCheckin,
    controllerAs: 'vm',
    bindings: {
      checkInId: '<',
      onComplete: '&'
    }
  });
  SleepScheduleCheckin.$inject = ['sleepScheduleSvc', 'sleepCheckInSvc', '$q', '$log', 'eventTrackingSvc'];
  /* @ngInject */
  function SleepScheduleCheckin(sleepScheduleSvc, sleepCheckInSvc, $q, $log, eventTrackingSvc) {
    var vm = this;
    vm.title = 'SleepScheduleCheckin';
    vm.schedule = {};

    vm.$onInit = function () {
      $log.debug('SleepScheduleCheckin $onInit');
      sleepScheduleSvc.getSchedule(true).then(function (schedule) {
        vm.schedule = schedule;
        vm.schedule.inBedTime = moment(schedule.inBedTime[0] + ":" + schedule.inBedTime[1], "HH:mm");
        vm.schedule.wakeUpTime = moment(schedule.wakeUpTime[0] + ":" + schedule.wakeUpTime[1], "HH:mm");
      });
    };

    vm.displayHour = function () {
      return Math.floor(vm.schedule.preferredMinutesInBed / 60);
    };

    vm.displayMinute = function () {
      return (vm.schedule.preferredMinutesInBed - vm.schedule.preferredMinutesInBed % 15) % 60;
    };

    vm.continueClick = function () {
      // update via an existing check-in id if present.
      var checkIn = {
        id: vm.checkInId
      };
      checkIn.checkInStatus = 'COMPLETE';

      // Save Weekly Checkin
      eventTrackingSvc.fireEvent('sleepTool', 'weeklyCheckin', 'scheduleScreen');
      var checkinRequest = sleepCheckInSvc.saveCheckIn(checkIn);

      // Save Schedule
      eventTrackingSvc.fireEvent('sleepTool', 'scheduleSaved', 'adjust');
      var scheduleRequest = sleepScheduleSvc.saveSchedule({
        recommendedMinutesInBed: vm.schedule.recommendedMinutesInBed,
        inBedTime: vm.schedule.inBedTime.format('HH:mm:ss.SSSSSSSSS'),
        wakeUpTime: vm.schedule.wakeUpTime.format('HH:mm:ss.SSSSSSSSS')
      });

      $q.when([checkinRequest, scheduleRequest]).then(function () {
        if (_.isFunction(vm.onComplete)) {
          vm.onComplete();
        } else {
          $log.error('msSleepScheduleCheckin: onComplete binding not set up correctly.', vm.onComplete);
        }
      });
    };
  }
})();